<div class="checkout-group" [formGroup]="mode">
  <div class="checkout-group-title">
    {{ 'checkout.group.deliveryMode.title' | cxTranslate }}
  </div>
  <div class="checkout-group-body">
    <ng-container *ngIf="(supportedDeliveryModes$ | async)?.length">
      <mat-form-field appearance="outline" class="mat-primary mat-form-field">
        <mat-label>{{ 'checkout.group.deliveryMode.title' | cxTranslate }}</mat-label>
        <mat-select
          appearance="outline"
          formControlName="deliveryModeId"
          (selectionChange)="changeMode($event.value)"
          disableOptionCentering
          panelClass="checkout-select"
        >
          <ng-container *ngFor="let mode of supportedDeliveryModes$ | async">
            <mat-option id="deliveryMode-{{ mode.code }}" [value]="mode.code">
              {{ mode.name }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </ng-container>
  </div>
</div>
